export const getLanguage = () => {
    return window.localStorage && window.localStorage.getItem('lng');
}